import { render, staticRenderFns } from "./background-check.vue?vue&type=template&id=876ebae6"
import script from "./background-check.vue?vue&type=script&lang=js"
export * from "./background-check.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports